import { CompRef } from '@wix/document-services-types';
import {
  WidgetPointer,
  PluginsHostApiContext,
} from '@wix/editor-platform-host-integration-apis';

import { PlatformContext } from '../../../types/platformApi';
import { SitePluginsHostIntegrationApi } from './types';

export class PluginService {
  hostAPI: SitePluginsHostIntegrationApi;

  constructor(hostAPI: SitePluginsHostIntegrationApi) {
    this.hostAPI = hostAPI;
  }

  public isPluginComponent(widgetPluginCompRef: CompRef) {
    return this.hostAPI.isPluginComponent(widgetPluginCompRef);
  }

  public async showOnPage(compRef: CompRef): Promise<void> {
    return this.hostAPI.showOnPage(compRef);
  }

  public async installWidgetPlugin(
    context: PlatformContext,
    slotComponentRef: CompRef,
    widgetRef: WidgetPointer,
    pluginsHostAPIContext: PluginsHostApiContext,
  ): Promise<CompRef> {
    return this.hostAPI.installWidgetPlugin(
      context,
      slotComponentRef,
      widgetRef,
      pluginsHostAPIContext,
    );
  }

  public async uninstallWidgetPlugin(
    context: PlatformContext,
    slotComponentRef: CompRef,
    pluginsHostAPIContext: PluginsHostApiContext,
  ): Promise<void> {
    return this.hostAPI.uninstallWidgetPlugin(
      context,
      slotComponentRef,
      pluginsHostAPIContext,
    );
  }
}
